import { Bar } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    LineElement,
    PointElement,
    Title,
    ArcElement,
    Tooltip,
    Legend,
} from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement, LineElement, PointElement, Title);

const bar_chart = ({ data, areaName, termTab }) => {
    
    const labels = data?.map(item => item.PTMIINDT);

    const myKeys = ['MY_KTS1', 'MY_KTS2', 'MY_KTS3', 'MY_KTS4', 'MY_KTS5'];
    const allKeys = ['ALL_KTS1', 'ALL_KTS2', 'ALL_KTS3', 'ALL_KTS4', 'ALL_KTS5'];
    const keys = ['KTS1', 'KTS2', 'KTS3', 'KTS4', 'KTS5'];

    const myKtsList = myKeys.map(key => data?.map(item => item[key]));
    const allKtsList = allKeys.map(key => data?.map(item => item[key]));
    const ktsList = keys.map(key => data?.map(item => item[key]));

    const selectedKtsList = areaName !== undefined ? myKtsList : termTab !== 'day' ? ktsList : allKtsList;
    const [data1, data2, data3, data4, data5] = selectedKtsList;

    const options = {
        maintainAspectRatio: false,
        responsive: true,
        spanGaps: false,
        indexAxis: "y", //가로형 막대 그래프 설정
        interaction:{
            mode:'index',
            intersect:false
        },
        plugins: {
            legend: {
                display: false,
                position: 'bottom',
            },
            title: {
                display: false,
                text: 'KTAS 등급',
                align: 'start',
                font: {size: 16},
                padding: {bottom: 20}
            }
        },
        scales: {
            x: {
                stacked:true
            },
            y: {
                display: true,
                stacked:true,
                ticks: {
                    display: true,
                    beginAtZero: false,
                },
            }
        },
    }
    
    const chartData = {
        labels,
        datasets: 
            [
                {
                    label: "1단계",
                    data: data1,
                    backgroundColor: 'rgb(101, 171, 235)',
                },
                {
                    label:'2단계',
                    data: data2,
                    backgroundColor: 'rgb(230, 121, 143)'
                },
                {
                    label: "3단계",
                    data: data3,
                    backgroundColor: 'rgb(246, 215, 106)',
                },
                {
                    label:'4단계',
                    data: data4,
                    backgroundColor: 'rgb(131, 199, 200)'
                },
                {
                    label:'5단계',
                    data: data5,
                    backgroundColor: 'rgb(143, 107, 229)'
                }
            ]
    }

    return (
        <div className='w-full h-full'>
            <Bar data={chartData} options={options} />
        </div>
    );
};
export default bar_chart;